import {
  CardPaymentManager,
  CardPaymentManagerData,
} from 'types/cardPaymentManagerTypes';
import { createCardPaymentMock } from 'utils/cardPaymentUtils';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createCardPaymentManagerData = (): CardPaymentManagerData => ({
  cardPayment: createCardPaymentMock(createUniqueRuntimeNumber()),
  cardPaymentInvalidated: false,
});

export const createCardPaymentManager = (): CardPaymentManager => ({
  cardPaymentId: null,
  data: createCardPaymentManagerData(),
});
